import React from 'react'

import classNames from 'classnames'

import { IconWrapper } from '../components'

export const IconPieChart = ({
  size,
  color,
  className,
  ...props
}: React.ComponentPropsWithoutRef<'svg'> & {
  size?: string | number
}) => (
  <IconWrapper {...props} className={classNames(className, "icon-centivo", "icon-centivo--pie-chart")} iconColor={color} size={size} width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">

      <defs>
          <path d="M7.60102304,1.91346727 C8.10721008,1.69257563 8.69662382,1.92385326 8.91751546,2.43004031 C9.1384071,2.93622735 8.90712947,3.52564109 8.40094242,3.74653273 C4.69417789,5.36410334 2.52163066,9.25558941 3.08985078,13.2598077 C3.65807091,17.2640259 6.82749183,20.397458 10.8379378,20.9199149 C14.8483837,21.4423718 18.7148067,19.2255274 20.2899424,15.5005327 C20.5050393,14.9918562 21.0917735,14.7538629 21.60045,14.9689597 C22.1091265,15.1840565 22.3471199,15.7707908 22.132023,16.2794673 C20.2068571,20.8322385 15.4812291,23.541715 10.5795729,22.9031566 C5.67791675,22.2645981 1.80418007,18.4348479 1.10968881,13.5408033 C0.415197546,8.64675878 3.07053305,3.89049802 7.60102304,1.91346727 Z M12.0009827,1 C14.9183641,1 17.7162572,2.15892524 19.7791573,4.22182541 C21.8420575,6.28472557 23.0009827,9.08261861 23.0009827,12 C23.0009827,12.5522847 22.5532675,13 22.0009827,13 L12.0009827,13 C11.448698,13 11.0009827,12.5522847 11.0009827,12 L11.0009827,2 C11.0009827,1.44771525 11.448698,1 12.0009827,1 Z M13.0009827,3.05569676 L13.0009827,11 L20.945286,11 C20.7196104,8.98098115 19.815371,7.0864662 18.3649438,5.63603897 C16.9145165,4.18561174 15.0200016,3.28137235 13.0009827,3.05569676 Z" id="icon--centivo--pie-chart"/>
      </defs>
      <g id="Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(-673.000000, -973.000000)"/>
          <g id="Icon/pie-chart">
              <mask id="mask-2" fill="white">
                  <use xlinkHref="#icon--centivo--pie-chart"/>
              </mask>
              <use id="Shape" fill="currentColor" xlinkHref="#icon--centivo--pie-chart"/>
          </g>
      </g>
  </IconWrapper>
)
